import { createContentPropTypes } from '../../../helpers/content';

const content = {
	name: 'Name',
	displayName: 'Nickname',
	sortCode: 'Sortcode',
	accountNumber: 'Account number',
	reference: 'Reference',
	header: 'New payee added',
	editPayeeSuccessHeader: 'Payee updated',
	alertMessage: ' has now been added to your list of payees.',
	editPayeeSuccessLeftLabel: 'The details for',
	editPayeeSuccessRightLabel: '  have now been updated.',
	accountsButtonLabel: 'Go to your accounts',
	managePayeeButtonLabel: 'Manage your payees',
	makePaymentsButtonLabel: 'Now make a payment to them',
	iban: 'IBAN',
	bic: 'BIC or SWIFT code',
	clearingCode: 'Clearing code',
	payeeAddress: 'Payee address',
	bankAddress: 'Bank address',
	referenceHighValue: 'Reason for payment',
	chapsReference: 'CHAPS reference',
	otherPaymentReference: 'Other payment reference',
	reasonForPayment: 'Reason for payment',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
